import { RADIO_TYPE, CHECKBOX_TYPE } from "Constants/FormElement";

export const FILTERS = [
    {
        id: 1,
        tabHeading: 'Event',
        contentJSON: [
            {
                label: 'Birthday',
                value: false
            }, 
            {
                label: 'Kitty',
                value: false
            }, 
            {
                label: 'Get together',
                value: false
            }, 
            {
                label: 'Gathering',
                value: false
            }, 
            {
                label: 'Other',
                value: false
            }
        ],
        type: CHECKBOX_TYPE
    },
    {
        id: 2,
        tabHeading: 'Meal',
        contentJSON: [
            {
                label: 'Breakfast',
                value: false
            }, 
            {
                label: 'Lunch',
                value: false
            }, 
            {
                label: 'starters',
                value: false
            }, 
            {
                label: 'Dinner',
                value: false
            }
        ],
        type: CHECKBOX_TYPE
    },
    {
        id: 3,
        tabHeading: 'Additional Requirements',
        contentJSON: [
            {
                label: 'Cleaner',
                value: true
            }, 
            {
                label: 'Waiter',
                value: false
            }
        ],
        type: RADIO_TYPE
    },
    {
        id: 4,
        tabHeading: 'Chef',
        contentJSON: [
            {
                label: 'Assigned',
                value: true
            }, 
            {
                label: 'Not assigned',
                value: false
            }
        ],
        type: RADIO_TYPE
    },
    {
        id: 5,
        tabHeading: 'Status',
        contentJSON: [
            {
                label: 'Resolved',
                value: false
            }, 
            {
                label: 'Progress',
                value: false
            }, 
            {
                label: 'Close',
                value: false
            }, 
        ],
        type: CHECKBOX_TYPE
    },
]